import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DateAdapter, MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatTreeModule } from '@angular/material/tree';
import { SvgIconsModule } from '@ngneat/svg-icon';
import { TranslateModule } from '@ngx-translate/core';
import { svgIcons } from '@tekman/shared/utils';
import { CustomDateAdapter } from './adapter/custom-date.adapter';
import { TekareaComponent } from './component/area-input/tekarea.component';
import { CheckboxTreeComponent } from './component/checkbox-tree/checkbox-tree.component';
import { CheckboxComponent } from './component/checkbox/checkbox.component';
import { GeogebraComponent } from './component/geogebra/geogebra.component';
import { MathComponent } from './component/math-input/math.component';
import { RadioButtonsComponent } from './component/radio-button/radio-buttons.component';
import { SelectComponent } from './component/select/select.component';
import { TekinputComponent } from './component/text-input/tekinput.component';
import { MathService } from './service/math.service';
import { RadioButtonsService } from './service/radio-buttons.service';
import { TekareaService } from './service/tekarea.service';
import { TekinputService } from './service/tekinput.service';
import { SharedComponentModule } from '@tekman/shared/component/shared';
import { MatSelectModule } from '@angular/material/select';
import { SplitOptionsPipe } from './pipes/split-options.pipe';
import { SnackBarComponent } from './component/snack-bar/snack-bar.component';
import { MatSnackBarAction, MatSnackBarActions, MatSnackBarLabel } from '@angular/material/snack-bar';
import { MatProgressSpinner } from '@angular/material/progress-spinner';

@NgModule({
  imports: [
    CommonModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatFormFieldModule,
    MatInputModule,
    TranslateModule,
    FormsModule,
    MatCheckboxModule,
    MatTreeModule,
    MatButtonModule,
    SharedComponentModule,
    SvgIconsModule.forChild(svgIcons),
    MatSelectModule,
    MatSnackBarLabel,
    MatSnackBarActions,
    MatSnackBarAction,
    MatProgressSpinner,
  ],
  declarations: [
    GeogebraComponent,
    MathComponent,
    RadioButtonsComponent,
    TekareaComponent,
    TekinputComponent,
    SelectComponent,
    CheckboxComponent,
    CheckboxTreeComponent,
    SplitOptionsPipe,
    SnackBarComponent,
  ],
  exports: [
    GeogebraComponent,
    MathComponent,
    RadioButtonsComponent,
    TekareaComponent,
    TekinputComponent,
    SelectComponent,
    CheckboxComponent,
    CheckboxTreeComponent,
  ],
  providers: [
    {
      provide: DateAdapter,
      useClass: CustomDateAdapter,
    },
    MathService,
    RadioButtonsService,
    TekareaService,
    TekinputService,
  ],
})
export class SharedComponentGenericModule {}
